const question = {
    yes: { values: ['E', 'D'] },
    no: { values: ['P'] },
    dunno: { values: ['P', 'E'] },
};

export default question;
